import { getTruckName } from 'domain/shipment/view/utils';

export const geDriversFetchPayloadUsingShipment = shipment => ({
  sender: shipment.sender,
  senderId: shipment.senderId,
  senderPhone: shipment.senderPhone,

  receiver: shipment.receiver,
  receiverPhone: shipment.receiverPhone,

  load: shipment.load,
  accessorials: shipment.accessorials,
  pickup: {
    latitude: shipment.pickup.coordinate.latitude,
    longitude: shipment.pickup.coordinate.longitude,
    time: shipment.pickup.arrivalWindow.begin,
  },
  dropoff: {
    latitude: shipment.dropoff.coordinate.latitude,
    longitude: shipment.dropoff.coordinate.longitude,
    time: shipment.dropoff.arrivalWindow.begin,
  },
});

export const morphReassignToQuotes = (resp, driver, state) => ({
  shipmentId: resp.shipmentQuotes[0].shipmentId,
  shipperId: resp.shipmentQuotes[0].shipperId,
  resources: {
    fleetId: resp.resources.fleetId,
    driver: resp.driver,
    vehicle: {
      ...driver.vehicle,
      truckName: getTruckName(driver.vehicle.vehicleType, state),
    },
  },
  itineraryId: resp.itineraryId,
  expectedDelivery: resp.shipmentQuotes[0].expectedDelivery,
  expectedPickup: resp.shipmentQuotes[0].expectedPickup,
  invoice: {
    shipmentId: resp.shipmentQuotes[0].shipmentId,
    invoiceType: 'ShipOrder',
    ...resp.invoice,
  },
  policies: [],
  leadEstimate: resp.shipmentQuotes[0].leadEstimate,
});

export const morphVehiclesToDrivers = vehicles => vehicles.reduce(
  (acc, result) => [
    ...acc,
    ...result.drivers.map(driver => ({
      ...driver,
      fleetId: result.fleetId,
      vehicle: result.vehicle,
    })),
  ],
  [],
);
